import React from 'react';
import {Popup} from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import ITpvRapportsXml from "../../models/ITpvRapportsXml";
import {FormListBase, FormListBaseTab, FormListBaseGrid} from '../base';
import {} from 'devextreme-react';
import useCustomDataSource from "../../hooks/useCustomDataSource";

export default function RapportsTpv() {
    const tpvRapportsFormDataSource = useCustomDataSource<ITpvRapportsXml, ITpvRapportsXml>({path: "tpvRapportsXml", primaryKey: "idTpvRapportsXml"});
    const {selectedDataRow: selectedTpvRapport, mode, setMode, isFieldModifier, setIsFieldModifier} = tpvRapportsFormDataSource;
    console.log(tpvRapportsFormDataSource)
    return (
        <Popup
            visible={true}
            // visible={this.state.popupVisible}
            // onHiding={this.hideInfo}
            dragEnabled={true}
            hideOnOutsideClick={true}
            showCloseButton={false}
            showTitle={true}
            title="Rapports TPV"
            container=".dx-viewport"
            width={350}
            height={300}
        >
            <ScrollView width='100%' height='100%'>
                <FormListBase data={tpvRapportsFormDataSource}>
                    <FormListBaseTab>
                        {/* <TabItem title="Informations">
              <Form>

              </Form>
            </TabItem> */}
                    </FormListBaseTab>
                </FormListBase>
            </ScrollView>
        </Popup>
    );
}